import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/layout/ProtectedRoute';
import AdminDashboardLayout from './components/layout/AdminDashboardLayout';
import LoginPage from './pages/LoginPage';
import OverviewPage from './pages/OverviewPage';
import ProjectsPage from './pages/ProjectsPage';
import ProjectEditor from './pages/ProjectEditor';
import ContactsPage from './pages/ContactsPage';
import AnalyticsPage from './pages/AnalyticsPage';
import SettingsPage from './pages/SettingsPage';
import JobsPage from './pages/JobsPage';
import JobEditor from './pages/JobEditor';
import ApplicationsPage from './pages/ApplicationsPage';
import ArticlesPage from './pages/ArticlesPage';
import ArticleEditor from './pages/ArticleEditor';
import HomePageEditor from './pages/HomePageEditor';
import ContactInfoPage from './pages/ContactInfoPage';
import TranslationsPage from './pages/TranslationsPage';
import FilesPage from './pages/FilesPage';
import FileDetailsPage from './pages/FileDetailsPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminDashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<OverviewPage />} />
          <Route path="projects" element={<ProjectsPage />} />
          <Route path="projects/new" element={<ProjectEditor />} />
          <Route path="projects/:id" element={<ProjectEditor />} />
          <Route path="homepage" element={<HomePageEditor />} />
          <Route path="contact-info" element={<ContactInfoPage />} />
          <Route path="translations" element={<TranslationsPage />} />
          <Route path="files" element={<FilesPage />} />
          <Route path="files/:id" element={<FileDetailsPage />} />
          <Route path="jobs" element={<JobsPage />} />
          <Route path="jobs/new" element={<JobEditor />} />
          <Route path="jobs/:id" element={<JobEditor />} />
          <Route path="applications" element={<ApplicationsPage />} />
          <Route path="articles" element={<ArticlesPage />} />
          <Route path="articles/new" element={<ArticleEditor />} />
          <Route path="articles/:id" element={<ArticleEditor />} />
          <Route path="contacts" element={<ContactsPage />} />
          <Route path="analytics" element={<AnalyticsPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Route>
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
